import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=03cd98bb&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./add.css?vue&type=style&index=0&id=03cd98bb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cd98bb",
  null
  
)

export default component.exports